export default __webpack_public_path__ + "static/media/NMC_16.e85c6b67.svg";